module.exports = __webpack_public_path__ + "static/media/gefactureerd_white.34b1cfe4.svg";